import FilterBar from 'components/common/FilterBar';
import { ISingleFilterOptionProps } from 'components/common/FilterBar/types';
import React from 'react';
import { OrderEnum } from 'types/common';

import { FilterContainerStyled } from './styled';

const ByDateAndLocationFilterBar: React.FC = () => {
  const filterByAscendingDateOrder = JSON.stringify({ date: OrderEnum.ASC });
  const filterByDescendingDateOrder = JSON.stringify({ date: OrderEnum.DESC });
  const filterByAscendingLocationOrder = JSON.stringify({ location: OrderEnum.ASC });
  const filterByDescendingLocationOrder = JSON.stringify({ location: OrderEnum.DESC });
  const options: ISingleFilterOptionProps[] = [
    { value: filterByAscendingDateOrder, label: 'Closest-Time First' },
    { value: filterByDescendingDateOrder, label: 'Furthest-Time First' },
    { value: filterByAscendingLocationOrder, label: 'By Location: Ascending' },
    { value: filterByDescendingLocationOrder, label: 'By Location: Descending' },
  ];
  return (
    <FilterContainerStyled style={{ width: 300, maxWidth: '33%' }}>
      <FilterBar notSpecifiedValueLabel='' options={options} name='order' defaultValue={filterByAscendingDateOrder} />
    </FilterContainerStyled>
  );
};

export default React.memo(ByDateAndLocationFilterBar);
